  (() => {
    const BALANCE_SELECTOR = "[data-toki-header-balance]"
    const HEADER_CONTAINERS = [".header__mobile__right", ".header__desktop__buttons--icons"]

    const injectStyles = () => {
      if (document.getElementById("toki-header-balance-styles")) return

      const style = document.createElement("style")
      style.id = "toki-header-balance-styles"
      style.textContent = `
        .toki-header-balance {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          gap: 4px;
          margin-right: 12px;
          color: var(--link);
          font-size: inherit;
          line-height: 1.1;
          white-space: nowrap;
          text-decoration: none;
        }

        .toki-header-balance:hover,
        .toki-header-balance:focus,
        .toki-header-balance:visited {
          color: var(--link);
          text-decoration: none;
        }

        .toki-header-balance[hidden] {
          display: none !important;
        }

        .toki-header-balance__label,
        .toki-header-balance__value {
          display: inline;
          color: var(--link);
        }

        .header__mobile__right .toki-header-balance {
          margin-right: 10px;
        }

        .header__mobile__right .toki-header-balance__label {
          display: none;
        }
      `

      document.head.append(style)
    }

    const createBalanceElement = () => {
      const element = document.createElement("a")
      element.href = "/pages/rewards"
      element.className = "navlink toki-header-balance"
      element.dataset.tokiHeaderBalance = ""
      element.hidden = true

      const label = document.createElement("span")
      label.className = "toki-header-balance__label"
      label.textContent = "Rewards:"

      const value = document.createElement("span")
      value.className = "toki-header-balance__value"
      value.dataset.tokiHeaderBalanceValue = ""

      element.append(label, value)
      return element
    }

    const injectBalanceElements = () => {
      HEADER_CONTAINERS.forEach(selector => {
        document.querySelectorAll(selector).forEach(container => {
          const exists = Array.from(container.children).some(child => child.matches?.(BALANCE_SELECTOR))
          if (!exists) container.prepend(createBalanceElement())
        })
      })
    }

    const getBalanceElements = () => document.querySelectorAll(BALANCE_SELECTOR)

    const hideBalance = () => {
      getBalanceElements().forEach(element => {
        element.hidden = true
      })
    }

    const formatBalance = (wallet, data) => {
      const balance = Number(data.balance)
      const conversionRate = Number(data.conversionRate)

      if (!Number.isFinite(balance) || !Number.isFinite(conversionRate) || conversionRate <= 0) {
        return null
      }

      const currency = wallet.config?.globalSettings?.currency?.code
      if (!currency) return null

      const formatting = data.formatCurrencyOptions || {}
      const configuredOptions = formatting.options || {}
      const { customTemplate, roundToConversionRate, ...intlOptions } = configuredOptions

      const currencyBalance = roundToConversionRate
        ? Math.floor(balance / conversionRate)
        : balance / conversionRate

      if (customTemplate) {
        const amount = new Intl.NumberFormat(formatting.locales, intlOptions).format(currencyBalance)
        const template = currencyBalance === 1 ? customTemplate.one : customTemplate.other
        return template.replace(/{{amount}}/g, amount)
      }

      return new Intl.NumberFormat(formatting.locales, {
        style: "currency",
        currency,
        ...intlOptions,
      }).format(currencyBalance)
    }

    const updateBalance = async () => {
      injectStyles()
      injectBalanceElements()

      const wallet = window.tokiWallet

      if (!wallet?.getUserBalance || !wallet?.toki_check_user_authenticated) {
        hideBalance()
        return
      }

      try {
        const isAuthenticated = await wallet.toki_check_user_authenticated()

        if (!isAuthenticated) {
          hideBalance()
          return
        }

        const data = await wallet.getUserBalance()
        const formattedBalance = formatBalance(wallet, data)

        if (!formattedBalance) {
          hideBalance()
          return
        }

        getBalanceElements().forEach(container => {
          const value = container.querySelector("[data-toki-header-balance-value]")
          if (value) value.textContent = formattedBalance
          container.hidden = false
        })
      } catch {
        hideBalance()
      }
    }

    window.__updateTokiHeaderBalance = updateBalance

    if (!window.__tokiHeaderBalanceListenersAdded) {
      const refreshBalance = () => window.__updateTokiHeaderBalance?.()

      window.addEventListener("tokiWalletRpcInjected", refreshBalance)
      window.addEventListener("tokiWalletUserAuthenticated", refreshBalance)
      window.addEventListener("tokiWalletBalanceChanged", refreshBalance)
      document.addEventListener("shopify:section:load", refreshBalance)

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", refreshBalance, { once: true })
      }

      window.__tokiHeaderBalanceListenersAdded = true
    }

    updateBalance()
  })()